import axios from "axios";

import { DATABASE_URL } from "../../constants";

// Importing all the services
import masterDataPanel from "./masterDataPanel";
import siteSurveyLinkApi from "./siteSurveyLinkApi";
import masterDataWeather from "./masterDataWeather";
import masterDataCountry from "./masterDataCountry";
import masterDataInverter from "./masterDataInverter";
import leads from "./leads";
import customTasklist from "./customTasklist.js";
import pipelines from "./pipeline";
import projects from "./projects";
import credits from "./credits";
import payments from "./payments";
import designs from "./designs";
import designsVersions from "./designVersions";
import organisation from "./organisations";
import users from "./users";
import incentiveInformation from "./incentiveInformation";
import financialsInformations from "./financialsInformations";
import ahjInformation from "./ahjInformation.js";
import defaultUserShares from "./defaultUserShares";
import defaultOrgShares from "./defaultOrgShares";
import designVersionScene from "./designVersionScene";
import designVersionSettings from "./designVersionSettings";
import designVersionSummary from "./designVersionSummary";
import projectModels from "./projectModels";
import projectConsumptionDetails from "./projectConsumptionDetails";
import projectTargets from "./projectTargets";
import defaultsProfiles from "./defaultsProfile";
import designFinancialDetails from "./designFinancialDetails";
import organisationInverters from "./organisationInverter";
import organisationPanels from "./organisationPanel";
import organisationBOQ from "./organisationBOQ";
import featureStatus from "./featureStatus";
import reports from "./reports";
import wireSizeCalculator from "./wireSizeCalculator.js";
import utils from "./utils";
import team from "./team.js";
import orderinformation from "./orderinformation";
import dashboardinfo from "./dashboardinfo";
import optimizerList from "./optimizerList";
import documentInfo from "./documentInfo";
import contracts from "./contracts.js";
import paymentSchedule from "./paymentSchedule.js";
import chatInfo from "./chatInformation";
import lidarInfo from "./lidarInfo";
import fetchMap from "./fetchMap";
import azureSasToken from "./azureSasToken";
import proposalInfo from "./proposalInfo";
import selfDesign from "./selfDesign";
import tou from "./tou";
import designOrders from "./designOrders";
import shifts from "./esUserShifts";
import competencies from "./competencies";
import crmDashboard from "./crmDashboard";
import addersDiscounts from "./adders&discounts";
import referralManagement from "./referralManagement"
import tasks from "./tasks";
import crmSettings from "./crmSettings";
import notifications from "./notifications";
import editableSiteSurvey from "./editableSiteSurvey";
import masterDataElectricVehicle from "./masterDataElectricVehicle";
import appliances from "./appliances.js";
import powerModels from "./powerModels";
import arkaOrders from "./arkaOrders.js";
import arkaProducts from "./arkaProducts.js";
import arkaAccessories from "./arkaAccessories.js";
import bundles from "./bundles";
import solutionsPayments from "./solutionsPayments.js";
import userManagement from "./userManagement.js";
import contractTemplates from "./contractTemplates.js";
import external from "./external.js";
import powerRoof from "./powerRoofApi";
import externalIntegrations from "./external.js"
import heatmap from "./heatmap.js";

export default {
  MASTER_DATA_PANEL: masterDataPanel,
  SITE_SURVEY_LINK: siteSurveyLinkApi,
  MASTER_DATA_WEATHER: masterDataWeather,
  MASTER_DATA_INVERTER: masterDataInverter,
  POWER_ROOF: powerRoof,
  PROJECTS: projects,
  CREDITS: credits,
  PAYMENTS: payments,
  DESIGNS: designs,
  POWERMODELS: powerModels,
  DESIGN_VERSIONS: designsVersions,
  ORGANISATION: organisation,
  EDITABLE_SITE_SURVEY: editableSiteSurvey,
  USERS: users,
  USER_MANAGEMENT: userManagement,
  ORG_SHARES: defaultOrgShares,
  USER_SHARES: defaultUserShares,
  PROJECT_MODELS: projectModels,
  PROJECT_TARGETS: projectTargets,
  DEFAULTS_PROFILE: defaultsProfiles,
  PROJECT_CONSUMPTION_DETAILS: projectConsumptionDetails,
  DESIGN_VERSION_SCENE: designVersionScene,
  DESIGN_VERSION_SETTINGS: designVersionSettings,
  DESIGN_VERSION_SUMMARY: designVersionSummary,
  DESIGN_FINANCIAL_DETAILS: designFinancialDetails,
  ORGANISATION_PANELS: organisationPanels,
  ORGANISATION_INVERTERS: organisationInverters,
  ORGANISATION_BOQ: organisationBOQ,
  FEATURE_STATUS: featureStatus,
  REPORTS: reports,
  UTILS: utils,
  MASTER_DATA_COUNTRY: masterDataCountry,
  WIRE_SIZE_CALCULATOR: wireSizeCalculator,
  INCENTIVE_INFORMATION: incentiveInformation,
  FINANACIALS_INFORMATION: financialsInformations,
  ORDER_INFORMATION: orderinformation,
  DASHBOARD_INFO: dashboardinfo,
  AHJ_INFORMATION: ahjInformation,
  TEAM: team,
  OPTIMIZER_LIST: optimizerList,
  DOCUMENT_INFO: documentInfo,
  CONTRACT_DETAILS:contracts,
  PAYMENT_SCHEDULE: paymentSchedule,
  CHAT_iNFO: chatInfo,
  LIDAR_INFO: lidarInfo,
  AZURE_SAS_TOKEN: azureSasToken,
  TOU: tou,
  PROPOSAL_INFO: proposalInfo,
  FETCH_MAP: fetchMap,
  SELF_DESIGN: selfDesign,
  DESIGN_ORDERS: designOrders,
  LEADS: leads,
  PIPELINES: pipelines,
  CRMSETTINGS: crmSettings,
  CUSTOM_TASK_LIST: customTasklist,
  SHIFTS: shifts,
  COMPETENCIES: competencies,
  CRM_DASHBOARD: crmDashboard,
  ADDERS_DISCOUNTS: addersDiscounts,
  TASKS: tasks,
  NOTIFICATIONS: notifications,
  EDITABLE_SITE_SURVEY_API: editableSiteSurvey,
  ARKA_ORDERS:arkaOrders,
  ARKA_PRODUCTS:arkaProducts,
  EXTERNAL_INTEGRATION: externalIntegrations,
  MASTER_DATA_ELECTRIC_VEHICLE: masterDataElectricVehicle,
  APPLIANCES: appliances,
  ARKA_ACCESSORIES:arkaAccessories,
  BUNDLES: bundles,
  SOLUTIONS_PAYMENTS: solutionsPayments,
  REFERRAL_MANAGEMENT: referralManagement,
  USER_MANAGEMENT: userManagement,
  CONTRACT_TEMPLATES :contractTemplates,
  EXTERNAL_INTEGRATION: external,
  HEATMAP: heatmap,
  SET_DATABASE_URL() {
    axios.defaults.baseURL = DATABASE_URL;
  },

  SET_TOKEN_HEADER(token) {
    if (token) {
      axios.defaults.headers.common.Authorization = `Token ${token}`;
    }
  },

  SET_AXIOS_RESPONSE_HANDLER() {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("user");
          window.location.href = "/login";
        }
        throw error;
      }
    );
  },
};
